import kaplay from 'kaplay'

const k = kaplay({
  scale: 2,
  global: false,
  width: 320,
  height: 240
})

export default k
